import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { useReactlytics } from '@americanexpress/reactlytics';
import { getLoadingText } from '../utils/streamableHelpers';
import styles from '../styles/PageWrapper.scss';
import ShutterSequence from './LoadingAnimation';

export const LoadingComponent = ({ loadingStep }) => {
  const intl = useIntl();
  const { track } = useReactlytics();

  useEffect(() => {
    track({
      event: {
        identifier: 'axp - WishlistBuilder - Chat',
        element: `StreamingOutput-${loadingStep}`,
        type: 'impression',
      },
    });
  }, [loadingStep, track]);

  return (
    <div
      style={{ margin: '3rem auto 0', padding: '0 3rem', minHeight: '500px' }}
      className="flex flex-item-grow flex-column flex-justify-start flex-align-center width-full"
    >
      <div
        className="
        heading-sans-xsmall-bold text-align-center width-full
        position-relative flex flex-justify-center
        flex-align-center
        "
        style={{
          height: '3.2em',
          overflow: 'hidden',
          marginBottom: '1rem',
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={loadingStep}
            initial={{ y: '100%' }}
            animate={{ y: '0%' }}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
            style={{
              position: 'absolute',
              width: '100%',
              left: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              style={{ maxWidth: '100%' }}
              className={styles.loadingText}
            >
              {getLoadingText(intl, loadingStep)}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
      <OnVisible analyticsInfo={{
        element: 'RecLoadingState',
        identifier: 'axp - WishlistBuilder - Chat',
      }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5, delay: 0.7 } }}
          aria-hidden="true"
          style={{ width: '100%' }}
        >
          <ShutterSequence />
        </motion.div>
      </OnVisible>
    </div>
  );
};

LoadingComponent.propTypes = {
  loadingStep: PropTypes.string.isRequired,
};
